import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PdButton from 'components/pd-button';
import { Col, Row, Layout, message, Modal } from 'antd';
import { get, capitalize } from 'lodash';
import { PageSpinner } from 'components/page-spinner';

import './style.scss';
import FlashsaleApi from 'services/flashsales';
import DataTable from 'react-data-table-component';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(customParseFormat);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
const { Content } = Layout;
const { confirm } = Modal;

export function FlashsaleList() {
  const [flashsalesActive, setFlashsalesActive] = useState([]);
  const [flashsalesInactive, setFlashsalesInactive] = useState([]);
  const [loadingPage, setLoadingPage] = useState(true);
  const [limit] = useState(10);

  async function getFlashsaleActive() {
    const { data } = await FlashsaleApi.getFlashsales('active');
    const FlashsaleData = data.data;
    setFlashsalesActive(FlashsaleData);
  }

  async function getFlashsaleInactive() {
    const { data } = await FlashsaleApi.getFlashsales('inactive');
    const FlashsaleData = data.data;
    setFlashsalesInactive(FlashsaleData);
  }

  async function getFlashsaleList() {
    try {
      setLoadingPage(true);
      await getFlashsaleActive();
      await getFlashsaleInactive();
    } catch (err) {
      const errMessage = get(
        get(get(err, 'response', {}), 'data', {}),
        'message',
        ''
      );
      if (errMessage) {
        message.error(errMessage);
      } else {
        message.error('Cannot connect to server, please check connection');
      }
    } finally {
      setLoadingPage(false);
    }
  }

  useEffect(() => {
    getFlashsaleList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limit]);

  async function deleteFlashsale(id) {
    try {
      if (id) {
        await FlashsaleApi.deleteFlashsale(id);
        message.success('Successfully removed flashsale');
      }
    } catch (err) {
      const errMessage = get(
        get(get(err, 'response', {}), 'data', {}),
        'message',
        ''
      );
      if (errMessage) {
        message.error(errMessage);
      } else {
        message.error('Cannot connect to server, please check connection');
      }
    } finally {
      getFlashsaleList();
    }
  }

  function handleHide(id) {
    confirm({
      title: 'Are you sure hide this flashsale?',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        deleteFlashsale(id);
      },
      onCancel() {},
    });
  }
  async function handleRestore(id) {
    try {
      if (id) {
        await FlashsaleApi.restoreFlashsale(id);
        message.success('Successfully restored flashsale');
      }
    } catch (err) {
      const errMessage = get(
        get(get(err, 'response', {}), 'data', {}),
        'message',
        ''
      );
      if (errMessage) {
        message.error(errMessage);
      } else {
        message.error('Cannot connect to server, please check connection');
      }
    } finally {
      getFlashsaleList();
    }
  }

  if (loadingPage) {
    return <PageSpinner />;
  }

  const ButtonGroup = (row) => {
    return (
      <Row style={{ width: '100%' }} gutter={20}>
        <Col span={12} className="button">
          {row.status === 'active' ? (
            <PdButton
              type="danger"
              outline
              full
              style={{ height: 40 }}
              onClick={() => handleHide(row.id)}>
              Deactivate
            </PdButton>
          ) : (
            <PdButton
              type="primary"
              outline
              full
              style={{ height: 40 }}
              onClick={() => handleRestore(row.id)}>
              Reactivate
            </PdButton>
          )}
        </Col>
        <Col span={12} className="button">
          <Link
            to={{
              pathname: '/flash_sales/edit',
              search: `id=${row.id}`,
            }}>
            <PdButton type="primary" full style={{ height: 40 }}>
              Edit
            </PdButton>
          </Link>
        </Col>
      </Row>
    );
  };
  const columns = [
    {
      name: 'Title',
      selector: row => row.title,
      width: '20%',
    },
    {
      name: 'Start Time',
      selector: row => row.start_time,
      width: '20%',
      format: (row) => dayjs(row.start_time).format('DD-MM-YYYY HH:mm'),
    },
    {
      name: 'End Time',
      selector: row => row.end_time,
      width: '20%',
      format: (row) => dayjs(row.end_time).format('DD-MM-YYYY HH:mm'),
    },
    {
      name: 'Status',
      selector: row => row.status,
      width: '15%',
      format: (row) => capitalize(row.status),
    },
    {
      name: '',
      cell: ButtonGroup,
      center: true,
    },
  ];
  const customStyles = {
    rows: {
      style: {
        minHeight: '72px', // override the row height,
        fontSize: '14px',
      },
    },
    headCells: {
      style: {
        paddingLeft: '8px', // override the cell padding for head cells
        fontSize: '14px',
        fontWeight: '700',
        paddingRight: '8px',
        color: 'rgba(0, 0, 0, 0.65)',
        background: '#F5F5F5',
      },
    },
    cells: {
      style: {
        paddingLeft: '8px', // override the cell padding for data cells
        paddingRight: '8px',
      },
    },
  };
  return (
    <Layout className="pd-cms-flashsale main-container">
      <div className="container">
        <div className="content">
          <div className="pageTitle">Flash Sale</div>
          <Content className="pageContent">
            <Row gutter={20}>
              <Col span={17}></Col>
              <Col span={7} className="float-right">
                <Link to={'/flash_sales/create'}>
                  <PdButton
                    type="primary"
                    outline
                    style={{ height: 40, width: 176 }}>
                    Add Flash Sale
                  </PdButton>
                </Link>
              </Col>
              <Col span={24}>
                <DataTable
                  customStyles={customStyles}
                  columns={columns}
                  data={flashsalesActive}
                />
              </Col>

              {flashsalesInactive.length > 0 && (
                <Col span={24} className="hidden-title-container">
                  <div className="pageTitle hiddenTitle">
                    Inactive Flash Sales
                  </div>
                </Col>
              )}

              <Col span={24}>
                <DataTable
                  customStyles={customStyles}
                  noHeader
                  columns={columns}
                  data={flashsalesInactive}
                />
              </Col>
            </Row>
          </Content>
        </div>
      </div>
    </Layout>
  );
}

export default { FlashsaleList };
